// background: '#fff',

export const styles = {
  root: {
    position: 'relative',
    padding: '4px 0px',
    borderBottom: '1px solid',
    paddingBottom: '10px'
  },
  img: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '132px',
    padding: '1rem',
    maxWidth: '150px',
    paddingRight: '1.25rem'
  },
  highlight: {
    display: 'flex',
    fontSize: '24px',
    fontWeight: 'bold'
  },
  title: {
    fontSize: '18px'
  },
  desc: {
    display: '-webkit-box',
    '-webkitBoxOrient': 'vertical',
    '-webkitLineClamp': '5',
    overflow: 'hidden'
  },
  footer: {
    fontSize: '14px',
    fontWeight: 'bold'
  }
};

// export const styles = {
//   Pod: {
//     position: 'relative'
//   },
//   grid: {},
//   list: {
//     img: {
//       display: 'flex',
//       flexBasis: '15rem',
//       alignItems: 'center'
//     },
//     Highlight: {
//       display: 'flex',
//       fontSize: '24px',
//       fontWeight: 'bold'
//     },
//     Title: {
//       fontSize: '18px'
//     },
//     Desc: {
//       fontSize: '14px'
//     },
//     Footer: {
//       fontSize: '14px',
//       fontWeight: 'bold'
//     }
//   }
// };
